import React from 'react'

export default function SearchWrapper({type,className,name, wrapperClass, onChange, value, placeholder}) {
  return (
    <div className={`search-wrapper ${wrapperClass}`}>
        <input type={type} name={name} className={`form-control ${className}`} onChange={onChange} value={value} placeholder={placeholder} />
    </div>
  )
}
